module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-profile__form"
  }, [(_vm.canEdit) ? _c('div', {
    staticClass: "d-profile__form__edit",
    on: {
      "click": function($event) {
        _vm.isEditable = !_vm.isEditable
      }
    }
  }, [(!_vm.isEditable) ? [_vm._v(_vm._s(_vm.$t('vue2.common.edit')))] : [_vm._v("Afslut redigering")]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-profile__form__body"
  }, [_c('h3', [_vm._v("Undervisningskompetencer (Linjefag)")]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bg-color": "#fff"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.competencies.length < 1) ? _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("\n      Ingen fag er tilføjet som kompetence\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "marg-1-top"
  }, [(_vm.isEditable) ? [_vm._m(0), _vm._v(" "), _c('label', {
    staticClass: "d-label marg-1-top marg-1-bottom"
  }, [_vm._v("Tilføj op til seks kompetencer")]), _vm._v(" "), _c('DSelect', {
    attrs: {
      "items": _vm.standardSubjectsWithVProps,
      "itemsSelected": _vm.userCompetencies,
      "show": true,
      "placeholder": "Tilføj kompetence"
    },
    on: {
      "update": function($event) {
        return _vm.updateSubjectOnUser($event)
      }
    }
  })] : _vm._e(), _vm._v(" "), (!_vm.isEditable) ? _c('ul', {
    staticClass: "linjefag linjefag--not-empty"
  }, [(_vm.userCompetencies.length === 0) ? _c('li', {
    staticClass: "linjefag__add"
  }, [_vm._v("\n          Tilføj op til seks kompetencer\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.userCompetencies), function(subject) {
    return _c('li', {
      staticClass: "d-pill"
    }, [_vm._v("\n          " + _vm._s(subject.name) + "\n        ")])
  })], 2) : _vm._e()], 2)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div-explainer"
  }, [_c('h3', [_vm._v("L eller K?")]), _vm._v(" "), _c('p', {
    staticClass: "text-explainer"
  }, [_c('b', [_vm._v("(L) Linjefag")]), _vm._v(": At have undervisningskompetence i et fag betyder, at\n            underviseren har haft det pågældende fag som linjefag på læreruddannelsen eller som ekstra linjefag på et\n            senere tidspunkt.")]), _vm._v(" "), _c('p', {
    staticClass: "text-explainer"
  }, [_c('b', [_vm._v("(K) Tilsvarende kompetence")]), _vm._v(": At have kompetence svarende til\n            undervisningskompetence betyder, at underviseren for eksempel har en efteruddannelse, videreuddannelse,\n            kompetencegivende uddannelse eller et længerevarende kursusforløb, der vurderes at give kompetence\n            svarende\n            til undervisningskompetence.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07b64efa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/ProfileSubjects.vue
// module id = 1444
// module chunks = 1